<template>
  <a-modal
    :title="isAdd ? '新建代理' : '修改代理'"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 代理名字 -->
      <a-form-item label="代理名字" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
          type="text"
          v-decorator="[
            'agentName',
            {rules: [{ required: true, pattern: /^.{2,10}$/, message: '请输入长度为2~10位的代理名' }], validateTrigger: 'change'}
          ]"
        />
      </a-form-item>

      <!-- 负责人 -->
      <a-form-item label="负责人" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-select
          class="form-cell"
          placeholder="请选择"
          v-decorator="[
            'managerId',
            {rules: [{ required: true, message: '请选择负责人' }]}
          ]"
        >
          <a-select-option
            v-for="(item,index) in listManager"
            :key="index"
            :value="item.id"
          >{{item.nickname}}</a-select-option>
        </a-select>
      </a-form-item>

      <!-- 地区 -->
      <a-form-item
        label="地区"
        class="form-oper"
        :labelCol="{lg: {span: 7}}"
        :wrapperCol="{lg: {span: 13}}"
      >
        <a-cascader
          :options="$store.state.common.address"
          placeholder="请选择"
          changeOnSelect
          :fieldNames="{label: 'name',value: 'id',children: 'children' }"
          v-decorator="[
            'addressSelect',
            {rules: [{ required: true, message: '请选择地区' }]}
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import person from "../../api/person";

import agency from "../../api/agency";

import {analysisAddress} from '../../utils/address'

export default {
  name: "submitForm",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      agencyId: '',
      updateData: {},
      listManager: [],
    };
  },
  methods: {
    //初始化，显示
    init(type,params) {
      this.visible = true;
      this.isAdd = type === 'add' ? true : false;

      //初始化form表单数据
      if(params){
        this.updateData = params;
        let formData = {};
        formData.agentName = params.agentName;
        formData.managerId = params.managerId;
        formData.addressSelect = [params.provinceId,params.cityId,params.districtId];
        //修改入口，要记录当前代理的ID
        this.agencyId = params.id;
        //重置负责人列表（修改的之后，列表里面会多一条当前已绑定的负责人）
        this.getListManager(formData.managerId);
        setTimeout(() => {
          this.form.setFieldsValue(formData);
        }, 100);
      }else{
        setTimeout(() => {
          this.form.resetFields();
          this.getListManager()
        }, 1);
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false;
      this.$emit('closeForm')
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, value) => {
        console.log("输入的内容是：", value);
        //校验通过
        if (!err) {
          let tempValue = analysisAddress(value);
          if(!tempValue.cityId){
            this.$message.error('请选择城市');
          }else{
            if (this.isAdd) {
              this.addAgency(tempValue);
            } else {
              this.updateAgency(tempValue);
            }
          }
        }
      });
    },

    //新增代理
    addAgency(value){
      agency.addAgency(value).then(res=>{
        this.$message.success("新增成功");
        this.handleCancel();
        this.$emit('addAgency',res.data)
      })
    },

    //修改代理
    updateAgency(value){
      agency.updateAgency(this.agencyId,value).then(res=>{
        this.$message.success("修改成功");
        Object.assign(this.updateData, value);
        this.$emit("updateAgency", res.data);
        this.handleCancel();
      })
    },

    //查询负责人
    getListManager(managerId) {
      let req = {
        roleId: "1",
      };
      if(managerId){
        req.managerId = managerId;
      }
      person.getListManager(req).then(res => {
        this.listManager = res.data;
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
</style>